import colorMappings from './lib/color-keys'
import Values from 'values.js'

export const setColor = async (customColor = {}) => {
  // select root element
  var r = document.querySelector(':root')

  colorMappings.forEach((item) => {
    // if the arg is same with base color, then don't set the variable
    if (!customColor[item.key] || item.baseColor === customColor[item.key]) return

    item.mappings.forEach((mapping) => {
      let tintedColor = customColor[item.key]
      let varName = item.varName
      let hexColorValue = new Values(tintedColor)

      // tint the color and change variable name
      if (mapping.type !== 'base') {
        if (mapping.percentage > 0) {
          hexColorValue = hexColorValue.tint(mapping.percentage)
        } else {
          hexColorValue = hexColorValue.shade(mapping.percentage * -1)
        }

        varName += `-${mapping.type}`
      }

      r.style.setProperty(varName, hexColorValue.hexString())
    })
  })
}
